module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_19.b5c39f53.png";